/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useMutation } from '@apollo/client' // Npm: Apollo client.
import { toast } from 'react-hot-toast' // Npm: React hot toast.


/*
 * SIBLINGS
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import AccessTokenDelete from './__mutation__/index.accessToken.delete.mutation'


/*
 * OBJECTS
 */
const Index = ({ accessTokenId, bindableId, bindToTable, onClose }) => {
  // Hook assignment.
  const [MutationAccessTokenDelete, MutationAccessTokenDeleteResponse] = useMutation(AccessTokenDelete)

  // Return Component.
  return (
    <DeleteCard onClose={onClose} onConfirm={() => MutationAccessTokenDelete({ 'variables': { accessTokenId, bindableId, bindToTable } }).then(i => {
      // Style Guide.
      toast(i?.data?.AccessTokenDelete?.message)

      // Report success.
      return onClose?.()
    }).catch(() =>
      // Style Guide.
      toast('Something went wrong please try after some time.'))} isLoading={MutationAccessTokenDeleteResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'accessTokenId': PropTypes.string,
  'bindableId': PropTypes.string,
  'bindToTable': PropTypes.string,
  'onClose': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
